import * as React from 'react'
import {ReactElement} from 'react'
import {Box} from '@mui/material'
import {Colors, FontSize} from '../../../../styledComponents/Constants'
import {FullWidthColumnFlexContainer, LeftRowFlexContainer} from '../../../../styledComponents/FlexComponents'
import {BlockSpacer} from '../../../../styledComponents/ResponsiveConvenience'
import {PlainBackLink} from '../../../../styledComponents/Links'
import {DisplayItemDividerForPageTop} from '../../../../styledComponents/DisplayItem'
import {Nullable} from '../../../../app/TypeHelpers'
import {
    ApplyButton,
    BoldText,
    ListGridContainer,
    PageTitle,
    PledgeArea,
    PolicyCheckBoxStyled,
} from '../common/resident/NatResidentApplicationsCommon'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet,
} from '../../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    applyId?: string
    location: Location
}

interface State {
    policyChecked: boolean
    applyButtonDisabled: boolean
}

class NatResidentBicycleParkingUseApplyAgreementPage
    extends React.Component<Props & ResidentWithErrorHandlingPagePropsSet, State> {

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)

        this.state = {
            policyChecked: false,
            applyButtonDisabled: true,
        }

        this.onChangePolicyChecked = this.onChangePolicyChecked.bind(this)
        this.onClickApplyButton = this.onClickApplyButton.bind(this)
    }

    onChangePolicyChecked(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            policyChecked: event.target.checked,
        }, () => {
            this.updateApplyButtonDisabled()
        })
    }

    updateApplyButtonDisabled(): void {
        const {policyChecked} = this.state

        if (policyChecked) {
            this.setState({applyButtonDisabled: false})
        } else {
            this.setState({applyButtonDisabled: true})
        }
    }

    onClickApplyButton(): void {
        this.props.navigate(
            `/resident/condominiums/${this.props.condominiumCd}/applications/bicycleParkingUses/input`,
            {
                state: {
                    applyId: this.props.applyId,
                },
            },
        )
    }

    renderPolicy(): Nullable<ReactElement> {

        return (<>
            <Box height={'15px'}/>
            <PledgeArea fontSize={FontSize.Middle}>
                <Box p={'10px'}>
                    <BoldText fontColor={Colors.AccentDark}>誓約文</BoldText>
                    <Box height={'5px'}/>
                    私は、本マンション自転車置場を使用したいので、自転車置場使用規則に掲げる収容可能な自転車の規格を確認のうえ、本書を提出いたします。
                </Box>
            </PledgeArea>
            <Box height={'20px'}/>
            <FullWidthColumnFlexContainer>
                <PolicyCheckBoxStyled>
                    <LeftRowFlexContainer>
                        <input
                            type="checkbox"
                            checked={this.state.policyChecked}
                            onChange={this.onChangePolicyChecked}
                        />
                        <BlockSpacer width={'10px'}/>
                        誓約文に同意する
                    </LeftRowFlexContainer>
                </PolicyCheckBoxStyled>
            </FullWidthColumnFlexContainer>
        </>)
    }


    render(): ReactElement {

        return (
            <>
                <PlainBackLink
                    to={this.props.applyId
                        ? `/resident/condominiums/${this.props.condominiumCd}/applications/bicycleParkingUses/${this.props.applyId}`
                        : `/resident/condominiums/${this.props.condominiumCd}/applications`}>
                    戻る
                </PlainBackLink>
                <BlockSpacer height={'16px'}/>
                <DisplayItemDividerForPageTop/>
                <BlockSpacer height={'30px'}/>
                <PageTitle>
                    自転車置場使用申請
                </PageTitle>
                <Box height={'20px'}/>
                <Box>
                    自転車置場を使用する場合に必ず提出が必要です。<BoldText>使用する区画を事前にご確認いただいたうえ</BoldText>で本申請手続きを実施してください。
                    <Box height={'10px'}/>
                    <ListGridContainer fontSize={FontSize.Middle}>
                        <div>・</div>
                        <div>
                            1区画ごとに申請が必要です。
                        </div>
                        <div>・</div>
                        <div>
                            自転車を変更する場合は、再度自転車置場使用申請を実施してください。
                        </div>
                        <div>・</div>
                        <div>
                            お手元に<BoldText>自転車登録番号（防犯登録番号）が確認できるもの</BoldText>をご用意いただくと、入力をスムーズに進めることができます。
                        </div>
                    </ListGridContainer>
                </Box>
                {this.renderPolicy()}
                <ApplyButton
                    disabled={this.state.applyButtonDisabled}
                    onClick={this.onClickApplyButton}>
                    <FullWidthColumnFlexContainer>
                        <div>
                            申請を開始する
                        </div>
                    </FullWidthColumnFlexContainer>
                </ApplyButton>
            </>
        )
    }
}

export default createResidentWithErrorHandlingPage(NatResidentBicycleParkingUseApplyAgreementPage)
